
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
import Resources from './_resources.mdx';
import Checklist from './_checklist.mdx';
const Layout = require('@/layouts/RootFileLayout').RootFileLayout;
const meta = {
  "title": "Here is the toolkit to develop your Automobiles Marketplace Platform, and Apps",
  "date": "2021-05-30"
};
const slug = 'automobiles-marketplace-app';
const tableOfContents = [];

const layoutProps = {
  Layout,
meta,
slug,
tableOfContents
};
const MDXLayout = require('@/layouts/CustomContentsLayout').CustomContentsLayout
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <p>{`Looking to build an automobiles marketplace and apps? Here is the toolkit to launch any marketplace without writing a single line of code.`}</p>
    <p>{`Tradly Platform has a simple user interface to build any marketplace like automobiles marketplace and can be controlled all the features in one single dashboard. It is a complete white label solution…`}</p>
    <p>{`The marketplace can be built on any platform, whether it is Android or iOS. Along with this option, you also get a web app template to get started.`}</p>
    <p>{`Here is an example of how you can configure the catalog, listing fields in your marketplace…`}</p>
    <Checklist mdxType="Checklist" />
    <Resources mdxType="Resources" />



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
